import React from 'react';

const TextInput = (props) => {
  return (
      <input type="text" className="form-control" maxLength="50" {...props} />
  );
}

export default TextInput;
